// Generated by ChatGPT
export const mimeLabels: Record<string, string> = {
	"application/vnd.google-earth.kml+xml": "KML",
	"application/vnd.google-earth.kmz": "KMZ",
	"application/json": "GeoJSON",
	"application/x-esri-shapefile": "Shapefile",
	"application/zip": "ZIP Archive",
	"image/tiff": "GeoTIFF",
	"image/png": "PNG",
	"image/jpeg": "JPEG",
	"text/csv": "CSV",
	"application/pdf": "PDF",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "Excel",
};

export function getLabelForMimeType(mime: string): string {
	return mimeLabels[mime] || mime;
}
